import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

const PasswordRequirementsContainer = props => {
    const { data } = props
    const label = data[0] // name of item
    const meetsReq = data[1] // boolean of whether or not req is satisfied

    return (
        <p style={{ marginBottom: 'unset' }}>{meetsReq ?
                <FontAwesomeIcon icon={faCheck} color="green" width='10' height='10' className={"padRight"} /> :
                <FontAwesomeIcon icon={faTimes} color="red" width='10' height='10' className={"padRight"} /> }
                {label}
            </p>
    );
};

export default PasswordRequirementsContainer;
